export default function ChapterMark({ index, label, tone = "sky", testid }) {
    const color = tone === "emerald" ? "text-emerald-300" : "text-sky-200";
    const rule = tone === "emerald" ? "bg-emerald-300/40" : "bg-sky-200/40";
    return (
        <div className="flex items-center gap-4 mb-4" data-testid={testid}>
            <span className={`font-display italic font-semibold text-xl leading-none ${color}`}>{index}</span>
            <span className={`h-px w-12 ${rule}`} aria-hidden="true" />
            <span className={`text-sm font-semibold tracking-[0.3em] uppercase ${color}`}>{label}</span>
        </div>
    );
}
